<div
    (click)="onMessageClick($event)"
    class="message"
    [style.top.px]="top()"
    [style.left.px]="left()"
    (animationend)="onAnimationEnd($event)"
    #tooltipMessage
>
    <div class="message-text" [innerHTML]="message()"></div>
    <img src="assets/img/tooltip/close.webp" (click)="dismiss()" class="close clickable">
</div>
